import React from 'react';

export const MagicIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2} {...props}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M12 18h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z" transform="rotate(-45 12 12)" />
    <path strokeLinecap="round" strokeLinejoin="round" d="M5 3l4 4M15 13l4 4M9 13l-2 2M13 9l2-2" />
  </svg>
);
